import _ from 'lodash'
import riderMessages from 'core/data-model/constants/validation-messages'
import { getToggles } from 'quick-quote/feature-toggles'

export const checkOccupationRule = (rule, eligibilities) => {
  const isMatchingRuleOccupationCode = (occupation) => occupation && occupation.occupationCode === rule.occupationCode

  const { occupation, otherOccupation } = eligibilities.insured

  let occupations = [occupation]

  if (getToggles().VALIDATE_OTHER_OCCUPATION) {
    occupations.push(otherOccupation)
  }

  const hasInvalidOccupation = _.some(occupations, isMatchingRuleOccupationCode)

  const errorMessage = hasInvalidOccupation ? riderMessages.RULE_RIDER_OCCUPATION : ''

  return {
    type: rule.validationType,
    message: errorMessage,
  }
}
